const data = [
    { name: "Immédiatement", id: 1 },
    { name: "Sous 15 jours", id: 2 },
    { name: "Sous 1 mois", id: 3 },
    { name: "Sous 2 mois", id: 4 },
    { name: "Sous 3 mois", id: 5 },
    { name: "Indéfini", id: 6 },
]

export const pourvoirs = data.sort((a, b) => a.name.localeCompare(b.name));
